// ============================================================
// MULTILINGUAL TRANSLATIONS - ALL UI TEXT
// Complete translation dictionary for Telugu, Hindi, and English
// ============================================================

const translations = {
  en: {
    // Report Screen
    reports: {
      title: "Reports",
      salesReports: "Sales Reports",
      today: "Today",
      thisWeek: "This Week",
      thisMonth: "This Month",
      thisYear: "This Year",
      totalSales: "Total Sales",
      grossProfit: "Gross Profit",
      expense: "Expense",
      topItemsTitle: "Top 5 Items By Gross-Profit",
      grossProfitVsCogs: "Gross Profit vs. Manufacturing Cost",
      noDataAvailable: "No profit data available for today",
      noSalesData: "No sales data available for this period",
      dailyContribution: "Daily Contribution",
      weeklyContribution: "Weekly Contribution",
      monthlyContribution: "Monthly Contribution",
      yearlyContribution: "Yearly Contribution",
      clickToSetBep: "Click to set BEP target",
      // Stock Report Labels
      before: "Before",
      after: "After",
      deducted: "Deducted",
      wasted: "Wasted",
      searchMaterials: "Search materials",
      lowStock: "Low Stock",
      sufficient: "Sufficient",
      keyInsights: "Key Insights",
      bestSellingItem: "Best Selling Item",
      mostWastedItem: "Most Wasted Item",
      rawMaterialStockReport: "Raw Material Stock Report",
      sales: {
        title: "Sales Reports",
        dailySummary: {
          title: "Daily Sales Summary",
          subtitle: "Overview of daily revenue"
        },
        saleTrend: {
          title: "Sale Trend",
          subtitle: "Gross Profit vs. COGS Distribution"
        },
        topItems: {
          title: "Top Items by Revenue",
          subtitle: "Sales distribution throughout the day"
        },
        onlineOrders: {
          title: "Online Orders",
          subtitle: "Track orders from online channels"
        }
      },
      stock: {
        title: "Stock Report",
        itemWise: {
          title: "Item Wise Sales Report",
          subtitle: "Items requiring immediate restock"
        },
        rawMaterial: {
          title: "Raw Material Stock Report",
          subtitle: "Current stock worth and valuation"
        },
        usage: {
          title: "Estimated vs Real-Time Usage",
          subtitle: "Consumption patterns and trends",
          menuItem: "Menu Item",
          estimated: "Estimated",
          actualPlates: "Actual Plates",
          variance: "Variance",
          plates: "Plates",
          noDataAvailable: "No data available for the selected period"
        }
      },
      online: {
        title: "Online Orders"
      },
      wastage: {
        title: "Wastage Reports",
        comparison: {
          title: "Wastage Comparison",
          subtitle: "Daily food waste tracking"
        }
      }
    },
    
    // Inventory Screen
    inventory: {
      title: "Inventory Overview",
      overview: "Overview",
      stock_in: "Stock In",
      stock_out: "Stock Out",
      categories: "Categories",
      allItems: "All Items",
      lowStock: "Low Stock",
      outOfStock: "Out of Stock",
      expiringSoon: "Expiring Soon",
      searchPlaceholder: "Search items...",
      search_placeholder: "Search items...",
      itemName: "Item Name",
      quantity: "Quantity",
      category: "Category",
      status: "Status",
      expiryDate: "Expiry Date",
      supplier: "Supplier",
      lastUpdated: "Last Updated",
      noItemsFound: "No items found",
      no_items_found: "No items found for",
      no_inventory_items: "No inventory items yet",
      add_items_hint: "Add items through",
      tab_to_see: "tab to see them here",
      go_to_stock_in: "Go to Stock In",
      filters: "Filters",
      sortBy: "Sort By",
      filter_expiry_nearest: "Expiry (Nearest First)",
      filter_newly_added: "Newly Added",
      filter_cost_high_low: "Cost (High to Low)",
      filter_cost_low_high: "Cost (Low to High)",
      filter_quantity_high_low: "Quantity (High to Low)",
      filter_quantity_low_high: "Quantity (Low to High)",
      filter_category: "By Category",
      filter_saved_prep: "Saved Prep",
      filter_not_associated: "Not Associated",
      filter_non_consumable: "Non Consumable",
      data_as_of: "Data as of",
      failed_to_load: "Failed to load inventory data",
      reconcile_stock: "Reconcile Stock",
      fix: "Fix",
      expired: "Expired",
      expires_today: "Expires Today",
      expires_tomorrow: "Expires Tomorrow",
      expires_in_days: "Expires in {{days}} days",
      fresh: "Fresh",
      no_expiry: "No Expiry",
      good: "Good",
      fifo_batch_details: "FIFO Batch Details",
      failed_batch_details: "Failed to load batch details",
      no_batch_details: "No batch details available",
      use_first: "USE FIRST",
      current: "Current",
      rop: "ROP",
      safety: "Safety",
      critical: "critical",
      low: "low",
      minimal_stock: "Minimal Stock",
      no_low_stock_items: "No low stock items right now."
    },
    
    // Common UI
    common: {
      search: "Search",
      filter: "Filter",
      back: "Back",
      next: "Next",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      add: "Add",
      update: "Update",
      loading: "Loading...",
      error: "Error",
      success: "Success",
      home: "Home",
      settings: "Settings",
      logout: "Logout",
      retry: "Retry",
      retrying: "Retrying...",
      allTime: "All Time",
      refresh: "Refresh"
    },
    
    // Reorder/Procurement
    reorder: {
      title: "Create Reorder",
      create_reorder: "Create Reorder",
      suggestedItems: "Suggested Items",
      itemName: "Item Name",
      currentStock: "Current Stock",
      reorderPoint: "Reorder Point",
      recommendedQty: "Recommended Quantity",
      vendor: "Vendor",
      estimatedCost: "Estimated Cost",
      createPO: "Create Purchase Order",
      addToCart: "Add to Cart"
    },
    
    // Stock-In Manual Entry
    stockIn: {
      title: "Stock In - Manual Entry",
      scanBill: "Scan Bill",
      manualEntry: "Manual Entry",
      vendorName: "Vendor Name",
      vendorNamePlaceholder: "Vendor Name from Bill",
      phoneNumber: "Phone Number",
      phonePlaceholder: "Vendor Phone (if available)",
      productionDate: "Production Date",
      shift: "Shift",
      morning: "Morning",
      evening: "Evening",
      items: "Purchase",
      itemName: "Item Name",
      itemNamePlaceholder: "Enter Item Name",
      searchItemsPlaceholder: "Search items...",
      category: "Category",
      categoryPlaceholder: "Select Category",
      quantity: "Quantity",
      quantityPlaceholder: "Enter Quantity",
      unit: "Unit",
      unitPlaceholder: "Enter Unit",
      unitPrice: "Total Unit Price",
      unitPricePlaceholder: "Enter Total Unit Price",
      batchNumber: "Batch Number",
      batchNumberPlaceholder: "Batch Number",
      expiryDate: "Expiry Date",
      expiryDatePlaceholder: "dd--mm--yyyy",
      addMoreItems: "+ Add More Items",
      totalCost: "Total Cost of Raw Materials",
      saveAsDraft: "Save as Draft",
      submit: "Submit",
      deleteItem: "Delete this item",
      selectShift: "Select shift",
      selectCategory: "Select category"
    },
    
    // Vendors
    vendors: {
      vendor: "Vendor"
    },
    
    // Notifications
    notifications: {
      title: "Notifications",
      backToDashboard: "Back to Dashboard",
      settings: "Settings",
      searchPlaceholder: "Search notifications...",
      loading: "Loading...",
      noNotifications: "No notifications",
      markAllAsRead: "✔ Mark All as Read",
      dismissAll: "✕ Dismiss All",
      refreshAll: "↻ Refresh All Notifications",
      viewDetails: "View details",
      hideDetails: "Hide details",
      markRead: "Mark read",
      dismiss: "Dismiss",
      loadingDetails: "Loading details…",
      failedToLoadDetails: "Failed to load details:",
      noDetails: "No details",
      // Notification types/tags
      inventory: "Inventory",
      stock: "Stock",
      recipe: "Recipe",
      lowStock: "Low Stock",
      info: "Info",
      warning: "Warning",
      alert: "Alert",
      success: "Success",
      // Details view
      shortOn: "short on",
      ingredients: "ingredient(s)",
      need: "need",
      have: "have",
      updated: "updated",
      changed: "changed",
      added: "added",
      removed: "removed",
      from: "from",
      to: "to",
      cost: "cost",
      // Notification Content Templates
      content: {
        wastageAlertTrendUp: "Wastage Alert: Trend Up in Last {{days}} Day(s)",
        wastageAlertDesc: "Your wastage cost trend is up by {{percent}}% over the last {{days}} day(s).",
        reminderWastageReport: "Reminder: Daily Wastage Report Due — {{date}}",
        reminderWastageDesc: "Your daily wastage report for {{date}} has not been submitted. Please record wastage to keep inventory and reports accurate.",
        reminderStockOutReport: "Reminder: Daily Stock Out Report Due — {{date}}",
        reminderStockOutDesc: "Your daily stock usage report for {{date}} has not been submitted. Please record sales and wastage to keep inventory accurate.",
        endOfDayReportReady: "End of Day Report Ready — {{date}}",
        endOfDayDesc: "Your daily report for {{date}} is ready. View sales, wastage, usage, and inventory impact.",
        restocked: "Restocked: {{item}}",
        restockedDesc: "Stock for {{item}} is now {{quantity}} {{unit}}, above reorder/safety thresholds.",
        recipeUpdated: "Recipe Updated: {{recipe}}",
        recipeUpdatedDesc: "The recipe for {{recipe}} was updated. {{count}} ingredients saved. Review ingredient mapping and costs if needed.",
        newInventoryItem: "New Inventory Item Created: {{item}}",
        newInventoryItemDesc: "We created a new inventory item \"{{item}}\" when updating the recipe {{recipe}}. Standard unit: {{unit}}. You may want to set reorder points, vendor, and ABC category.",
        zeroCostRecipe: "Zero-Cost Recipe: {{recipe}}",
        zeroCostRecipeDesc: "The recipe for {{recipe}} has no cost data. Ensure raw ingredients have cost per unit in Stock In/Inventory.",
        unmappedIngredient: "Unmapped Ingredient Unit: {{ingredient}}",
        unmappedIngredientDesc: "The ingredient {{ingredient}} in recipe {{recipe}} uses unit \"{{recipeUnit}}\" but the inventory item uses \"{{inventoryUnit}}\". Add a unit conversion so deductions are accurate."
      }
    },
    
    // Vendor Management
    vendorCategories: {
      all: "All",
      wholesale: "Wholesale",
      dairy: "Dairy",
      meat: "Meat",
      seafood: "Seafood",
      vegetables: "Vegetables",
      fruits: "Fruits",
      others: "Others"
    },
    vendorManagement: {
      title: "Vendor Management",
      search_placeholder: "Search vendors...",
      total_spend: "Total Spend",
      this_period: "(This Period)",
      total_credit_extended: "Total Credit Extended",
      add_credit: "Add Credit",
      add_vendor: "Add a Vendor",
      no_vendors_found: "No vendors found for the selected filter",
      select_all: "Select 'All' or add a new vendor",
      on_time: "On-time",
      quality: "Quality",
      contact: "Contact",
      view_details: "View Details"
    },
    
    // Stock Out
    stockOut: {
      usage: "Usage",
      waste: "Waste",
      reason: "Reason",
      select_reason: "Select reason",
      change: "Change",
      search_placeholder: "Search items...",
      wastage_date: "Wastage Date",
      all: "All",
      main_course: "Main Course",
      raw_items: "Raw Items",
      no_wastage: "No wastage recorded",
      excess_preparation: "Excess Preparation",
      spoilage: "Spoilage",
      expired: "Expired",
      low_stock: "Low Stock",
      out_of_stock: "Out of Stock",
      overstocked: "Overstocked",
      adequate: "Adequate",
      available: "available",
      days_to_expiry: "Days to expiry",
      submit: "Submit",
      cancel: "Cancel",
      total_items: "Total Items",
      estimated_waste_cost: "Estimated Waste Cost",
      manufacturing_cost: "Manufacturing Cost"
    },
    
    // Daily Production Planning (Usage Page)
    productionPlanning: {
      title: "Daily Production Planning",
      todaysRevenueForecast: "Today's Revenue Forecast",
      itemsPlanned: "Items Planned",
      avgConfidence: "Avg Confidence",
      smartRecommendations: "Smart Recommendations",
      priority: "Priority",
      high: "High",
      medium: "Medium",
      low: "Low",
      apply: "Apply",
      dismiss: "Dismiss",
      searchMenuItems: "Search menu items...",
      saveChanges: "Save Changes",
      confirmTodaysPlan: "Confirm Today's Plan",
      reviewPlan: "Review Your Production Plan",
      pleaseReview: "Please take a moment to review your quantities. You have:",
      secondsRemaining: "seconds remaining",
      totalItems: "Total Items",
      estimatedRevenue: "Estimated Revenue",
      modifiedItems: "Modified Items",
      confirmProductionPlan: "Confirm Production Plan",
      pleaseWaitToConfirm: "Please wait to confirm your plan...",
      loadingPlan: "Loading your production plan...",
      noItemsFound: "No items found",
      noItemsMatch: "No items match",
      tryAdjusting: "Try adjusting your search.",
      noPlanForDate: "No production plan for this date. The system will generate recommendations based on your sales history.",
      uncategorized: "Uncategorized",
      per: "per",
      item: "item",
      confidence: "confidence",
      plannedQuantity: "Planned Quantity",
      estRevenue: "Est. Revenue",
      manual: "Manual",
      recentAvg: "Recent avg",
      sameDayAvg: "Same day avg",
      modified: "Modified"
    },
    
    // Usage Component (Production Planning Form)
    usage: {
      productionDate: "Production Date",
      allDayShift: "All Day",
      morningShift: "Morning Shift",
      afternoonShift: "Afternoon Shift",
      eveningShift: "Evening Shift",
      nightShift: "Night Shift",
      items: "Items",
      addItems: "Add Items",
      addMoreItems: "Add More Items",
      notes: "Notes",
      notesPlaceholder: "Add notes here...",
      submit: "Submit",
      estimatedCost: "Estimated Cost",
      confirmUsageRecord: "Confirm Usage Record",
      totalItems: "Total Items",
      shift: "Shift",
      shiftTime: "Shift Time",
      cancel: "Cancel",
      confirm: "Confirm",
      processing: "Processing...",
      successMessage: "Usage data submitted successfully!",
      pleaseAddItems: "Please add at least one item before submitting.",
      invalidQuantities: "Some items have invalid quantities. Please check and try again.",
      plates: "Plates",
      searchItems: "Search items..."
    },
    
    // Waste Component (Waste Recording Form)
    waste: {
      selectWasteReason: "Select Waste Reason",
      selectStaffMember: "Select Staff Member",
      confirmWasteRecord: "Confirm Waste Record",
      totalItems: "Total Items",
      estimatedWasteCost: "Estimated Waste Cost",
      reason: "Reason",
      recordedBy: "Recorded by",
      cancel: "Cancel",
      confirm: "Confirm",
      processing: "Processing...",
      photoRequired: "Photo Required",
      confirmWaste: "Confirm Waste",
      photoEvidenceRequired: "Photo Required",
      highValueWasteDetected: "High-Value Waste Detected",
      addPhotoInstruction: "Please add at least one photo before confirming this waste record.",
      howToAddPhoto: "How to add a photo:",
      clickCameraIcon: "Capture Photo",
      captureMultiplePhotos: "You can capture multiple photos for better documentation",
      goBack: "Go Back",
      proceedWithoutPhoto: "Proceed Without Photo",
      successMessage: "Waste record submitted successfully!"
    },
    
    // Settings Page
    settings: {
      title: "Settings",
      page_title: "Settings",
      financials_profitability: "Financials & Profitability",
      net_profit_analyzer: "Net Profit Analyzer",
      simulate_profitability: "Simulate month-end profitability and close scenarios",
      search_settings: "Search settings...",
      
      // Notification Preferences
      notification_preferences: "Notification Preferences",
      critical_stock_alerts: "Critical Stock Alerts",
      high_value_transactions: "High-Value Transactions",
      
      // Account Management Section
      account_management: "Account Management",
      my_profile: "My Profile",
      view_edit_profile: "View and edit your profile",
      change_password: "Change Password",
      update_account_security: "Update your account security",
      app_language: "App Language",
      sign_out: "Sign Out",
      logout_account: "Logout from your account",
      
      // Edit Profile Modal
      edit_profile: "Edit Profile",
      full_name: "Full Name",
      email_address: "Email Address",
      phone_number: "Phone Number",
      save_changes: "Save Changes",
      cancel: "Cancel",
      
      // Change Password Modal
      current_password: "Current Password",
      new_password: "New Password",
      confirm_new_password: "Confirm New Password",
      password_requirements: "Password must be at least 8 characters",
      update_password: "Update Password",
      
      // Language Modal
      select_language: "Select Language",
      english: "English",
      telugu: "తెలుగు",
      hindi: "हिंदी",
      
      // Business & Location
      business_profile: "Restaurant Profile",
      business_details: "Business name, address, contact details",
      manage_locations: "Manage Locations",
      active_branches: "active branches",
      operating_hours: "Operating Hours",
      configure_shifts: "Configure business shifts",
      
      // Inventory Management
      inventory_management: "Inventory Management",
      units_of_measure: "Units of Measure",
      manage_units: "Manage KG, L, Pieces, Plates",
      reorder_defaults: "Reorder Point Defaults",
      automatic_reorder: "Set automatic reorder rules",
      inventory_categories: "Inventory Categories",
      category_types: "Produce, Dairy, Meat, Dry Goods",
      
      // Sales & Menu Management
      sales_menu: "Sales & Menu Management",
      menu_categories: "Menu Categories",
      menu_types: "Breakfast, Lunch, Beverages",
      tax_rates: "Tax Rates",
      tax_config: "GST/VAT configuration",
      payment_methods: "Payment Methods",
      payment_types: "Cash, UPI, Card, Wallets",
      localized_pricing: "Localized Pricing",
      branch_pricing: "Allow branch-specific pricing",
      
      // Vendor & Procurement
      vendor_procurement: "Vendor & Procurement",
      manage_vendors: "Manage Vendors",
      active_suppliers: "active suppliers",
      payment_terms: "Default Payment Terms",
      net_days: "Net Days",
      
      // Wastage & Production
      wastage_production: "Wastage & Production",
      wastage_reasons: "Wastage Reasons",
      wastage_types: "Expired, Spillage, Overcooked",
      yield_tolerances: "Production Yield Tolerances",
      deviation_alert: "Alert at deviation",
      
      // App Information & Support
      app_info_support: "App Information & Support",
      help_support: "Help & Support",
      help_resources: "FAQ, Contact, Tutorials",
      about_app: "About Invexis",
      app_version: "Version 1.2.3",
      
      // Common
      save: "Save",
      close: "Close",
      add: "Add",
      edit: "Edit",
      delete: "Delete",
      search: "Search",
      clear: "Clear",
      apply: "Apply",
      reset: "Reset"
    },
    
    // Sidebar/User Management
    sidebar: {
      user_access_management: "User & Access Management",
      invite_new_user: "Invite New User",
      send_invitation: "Send invitation to new team member",
      manage_users: "Manage Users",
      total_users: "total users",
      active: "active",
      roles_permissions: "Roles & Permissions",
      roles_configured: "roles configured",
      location_assignment: "Location Assignment",
      assign_users: "Assign users to specific locations",
      two_factor_authentication: "Two-Factor Authentication",
      enhanced_security: "Enhanced security for all accounts",
      activity_logs: "Activity Logs",
      view_user_actions: "View user actions and changes",
      business_location_management: "Business & Location Management",
      
      // Invite User Form
      name: "Name",
      email: "Email",
      phone: "Phone",
      role: "Role",
      select_role: "Select Role",
      locations: "Locations",
      select_locations: "Select Locations",
      send_invite: "Send Invite",
      
      // User Management
      user_list: "User List",
      status: "Status",
      last_active: "Last Active",
      actions: "Actions",
      deactivate: "Deactivate",
      activate: "Activate",
      edit_user: "Edit User",
      delete_user: "Delete User"
    },
    
    // Waste Reason Labels (Database translations)
    wasteReasons: {
      "Pest Contamination": "Pest Contamination",
      "Quality Control Rejection": "Quality Control Rejection",
      "Spoilage - Damaged": "Spoilage - Damaged",
      "Spoilage - Expired": "Spoilage - Expired",
      "Storage Issue": "Storage Issue",
      "Temperature Control Failure": "Temperature Control Failure",
      "Customer Return - Complaint": "Customer Return - Complaint",
      "Kitchen Mistake": "Kitchen Mistake",
      "Over-production": "Over-production",
      "Under-production Waste": "Under-production Waste",
      "Equipment Failure": "Equipment Failure",
      "Staff Training Error": "Staff Training Error",
      "billing errors": "Billing Errors",
      "spillage": "Spillage",
      "spoilage": "Spoilage",
      "Overcooked": "Overcooked",
      "Customer Return": "Customer Return",
      "Preparation Error": "Preparation Error",
      "Spoilage (Prepared)": "Spoilage (Prepared)",
      "Excess Preparation": "Excess Preparation",
      "No wastage recorded": "No wastage recorded",
      "Ingredient Waste": "Ingredient Waste",
      "Dish Waste": "Dish Waste",
      "General Waste": "General Waste",
      "Food Preparation": "Food Preparation",
      "Service Issue": "Service Issue",
      "Food Quality": "Food Quality",
      "Inventory Management": "Inventory Management",
      "Administrative": "Administrative",
      "No Waste": "No Waste"
    }
  },
  
  te: {
    // Report Screen (Telugu)
    reports: {
      title: "రిపోర్టులు",
      salesReports: "అమ్మకాల రిపోర్టులు",
      today: "నేడు",
      thisWeek: "ఈ వారం",
      thisMonth: "ఈ నెల",
      thisYear: "ఈ సంవత్సరం",
      totalSales: "మొత్తం అమ్మకాలు",
      grossProfit: "స్థూల లాభం",
      expense: "ఖర్చు",
      topItemsTitle: "స్థూల లాభ సహకారం ద్వారా టాప్ 5 వస్తువులు",
      grossProfitVsCogs: "స్థూల లాభం vs తయారీ ఖర్చు పంపిణీ",
      noDataAvailable: "నేటికి లాభ డేటా అందుబాటులో లేదు",
      noSalesData: "ఈ కాలానికి అమ్మకాల డేటా అందుబాటులో లేదు",
      dailyContribution: "రోజువారీ సహకారం",
      weeklyContribution: "వారపు సహకారం",
      monthlyContribution: "నెలవారీ సహకారం",
      yearlyContribution: "వార్షిక సహకారం",
      clickToSetBep: "BEP లక్ష్యాన్ని సెట్ చేయడానికి క్లిక్ చేయండి",
      // Stock Report Labels (Telugu)
      before: "ముందు",
      after: "తరువాత",
      deducted: "తీసివేసినది",
      wasted: "వృథా చేసినది",
      searchMaterials: "పదార్థాలను శోధించండి",
      lowStock: "తక్కువ స్టాక్",
      sufficient: "తగినంత",
      keyInsights: "ముఖ్య సమాచారం",
      bestSellingItem: "అత్యధికంగా అమ్ముడైన వస్తువు",
      mostWastedItem: "అత్యధికంగా వృథా చేసిన వస్తువు",
      rawMaterialStockReport: "ముడి పదార్థాల స్టాక్ రిపోర్ట్",
      sales: {
        title: "అమ్మకాల రిపోర్టులు",
        dailySummary: {
          title: "రోజువారీ అమ్మకాల సారాంశం",
          subtitle: "రోజువారీ ఆదాయం మరియు లావాదేవీల అవలోకనం"
        },
        saleTrend: {
          title: "అమ్మకాల ధోరణి",
          subtitle: "స్థూల లాభం వర్సెస్ COGS పంపిణీ"
        },
        topItems: {
          title: "ఆదాయం ద్వారా టాప్ వస్తువులు",
          subtitle: "రోజంతా అమ్మకాల పంపిణీ"
        },
        onlineOrders: {
          title: "ఆన్‌లైన్ ఆర్డర్లు",
          subtitle: "ఆన్‌లైన్ ఛానెళ్ల నుండి ఆర్డర్లను ట్రాక్ చేయండి"
        }
      },
      stock: {
        title: "స్టాక్ రిపోర్ట్",
        itemWise: {
          title: "వస్తువుల వారీగా అమ్మకాల నివేదిక",
          subtitle: "తక్షణ పునఃనిల్వ అవసరమైన వస్తువులు"
        },
        rawMaterial: {
          title: "ముడి పదార్థాల స్టాక్ నివేదిక",
          subtitle: "ప్రస్తుత స్టాక్ విలువ మరియు వాల్యుయేషన్"
        },
        usage: {
          title: "అంచనా vs రియల్-టైమ్ వినియోగం",
          subtitle: "వినియోగ నమూనాలు మరియు ధోరణులు",
          menuItem: "మెనూ వస్తువు",
          estimated: "అంచనా",
          actualPlates: "అసలు ప్లేట్లు",
          variance: "వైవిధ్యం",
          plates: "ప్లేట్లు",
          noDataAvailable: "ఎంచుకున్న కాలానికి డేటా అందుబాటులో లేదు"
        }
      },
      online: {
        title: "ఆన్‌లైన్ ఆర్డర్లు"
      },
      wastage: {
        title: "వ్యర్ధ రిపోర్టులు",
        comparison: {
          title: "వ్యర్థ పోలిక",
          subtitle: "రోజువారీ ఆహార వ్యర్థ ట్రాకింగ్"
        }
      }
    },
    
    // Inventory Screen (Telugu)
    inventory: {
      title: "ఇన్వెంటరీ అవలోకనం",
      overview: "అవలోకనం",
      stock_in: "స్టాక్ ఇన్",
      stock_out: "స్టాక్ అవుట్",
      categories: "వర్గాలు",
      allItems: "అన్ని వస్తువులు",
      lowStock: "తక్కువ స్టాక్",
      outOfStock: "స్టాక్ అయిపోయింది",
      expiringSoon: "త్వరలో గడువు ముగుస్తుంది",
      searchPlaceholder: "వస్తువులను శోధించండి...",
      search_placeholder: "వస్తువులను శోధించండి...",
      itemName: "వస్తువు పేరు",
      quantity: "పరిమాణం",
      category: "వర్గం",
      status: "స్థితి",
      expiryDate: "గడువు తేదీ",
      supplier: "సరఫరాదారు",
      lastUpdated: "చివరిగా నవీకరించబడింది",
      noItemsFound: "వస్తువులు కనుగొనబడలేదు",
      no_items_found: "వస్తువులు కనుగొనబడలేదు",
      no_inventory_items: "ఇంకా ఇన్వెంటరీ వస్తువులు లేవు",
      add_items_hint: "ద్వారా వస్తువులను జోడించండి",
      tab_to_see: "ట్యాబ్ వాటిని ఇక్కడ చూడటానికి",
      go_to_stock_in: "స్టాక్ ఇన్‌కి వెళ్ళండి",
      filters: "ఫిల్టర్లు",
      sortBy: "క్రమబద్ధీకరించు",
      filter_expiry_nearest: "గడువు (సమీప ముందుగా)",
      filter_newly_added: "కొత్తగా జోడించబడింది",
      filter_cost_high_low: "ఖర్చు (అధికం నుండి తక్కువ)",
      filter_cost_low_high: "ఖర్చు (తక్కువ నుండి అధికం)",
      filter_quantity_high_low: "పరిమాణం (అధికం నుండి తక్కువ)",
      filter_quantity_low_high: "పరిమాణం (తక్కువ నుండి అధికం)",
      filter_category: "వర్గం ద్వారా",
      filter_saved_prep: "సేవ్ చేసిన ప్రిపరేషన్",
      filter_not_associated: "అనుసంధానం కానివి",
      filter_non_consumable: "నాన్ కన్స్యూమబుల్",
      data_as_of: "డేటా నాటికి",
      failed_to_load: "ఇన్వెంటరీ డేటా లోడ్ చేయడంలో విఫలమైంది",
      reconcile_stock: "స్టాక్ సరిచేయండి",
      fix: "సరిచేయండి",
      expired: "గడువు ముగిసింది",
      expires_today: "ఈరోజు గడువు ముగుస్తుంది",
      expires_tomorrow: "రేపు గడువు ముగుస్తుంది",
      expires_in_days: "{{days}} రోజుల్లో గడువు ముగుస్తుంది",
      fresh: "తాజా",
      no_expiry: "గడువు లేదు",
      good: "మంచిది",
      fifo_batch_details: "FIFO బ్యాచ్ వివరాలు",
      failed_batch_details: "బ్యాచ్ వివరాలను లోడ్ చేయడం విఫలమైంది",
      no_batch_details: "బ్యాచ్ వివరాలు అందుబాటులో లేవు",
      use_first: "మొదట ఉపయోగించండి",
      current: "ప్రస్తుత",
      rop: "ROP",
      safety: "భద్రత",
      critical: "క్లిష్టమైన",
      low: "తక్కువ",
      minimal_stock: "కనీస స్టాక్",
      no_low_stock_items: "ప్రస్తుతం తక్కువ స్టాక్ వస్తువులు లేవు."
    },
    
    // Common UI (Telugu)
    common: {
      search: "శోధించు",
      filter: "ఫిల్టర్",
      back: "వెనుకకు",
      next: "తదుపరి",
      save: "సేవ్ చేయండి",
      cancel: "రద్దు చేయండి",
      delete: "తొలగించు",
      edit: "సవరించు",
      add: "జోడించు",
      update: "నవీకరించు",
      loading: "లోడ్ అవుతోంది...",
      error: "లోపం",
      success: "విజయం",
      home: "హోమ్",
      settings: "సెట్టింగ్‌లు",
      logout: "లాగ్అవుట్",
      retry: "మళ్ళీ ప్రయత్నించండి",
      retrying: "మళ్ళీ ప్రయత్నిస్తోంది...",
      allTime: "అన్ని సమయం",
      refresh: "రిఫ్రెష్ చేయండి"
    },
    
    // Reorder/Procurement (Telugu)
    reorder: {
      title: "రీఆర్డర్ సృష్టించండి",
      create_reorder: "రీఆర్డర్ సృష్టించండి",
      suggestedItems: "సూచించిన వస్తువులు",
      itemName: "వస్తువు పేరు",
      currentStock: "ప్రస్తుత స్టాక్",
      reorderPoint: "రీఆర్డర్ పాయింట్",
      recommendedQty: "సిఫార్సు చేయబడిన పరిమాణం",
      vendor: "విక్రేత",
      estimatedCost: "అంచనా ఖర్చు",
      createPO: "కొనుగోలు ఆర్డర్ సృష్టించండి",
      addToCart: "కార్ట్‌కు జోడించండి"
    },
    
    // Stock-In Manual Entry (Telugu)
    stockIn: {
      title: "స్టాక్ ఇన్ - మాన్యువల్ ఎంట్రీ",
      scanBill: "బిల్లు స్కాన్ చేయండి",
      manualEntry: "మాన్యువల్ ఎంట్రీ",
      vendorName: "విక్రేత పేరు",
      vendorNamePlaceholder: "బిల్లు నుండి విక్రేత పేరు",
      phoneNumber: "ఫోన్ నంబర్",
      phonePlaceholder: "విక్రేత ఫోన్ (అందుబాటులో ఉంటే)",
      productionDate: "ఉత్పత్తి తేదీ",
      shift: "షిఫ్ట్",
      morning: "ఉదయం",
      evening: "సాయంత్రం",
      items: "కొనుగోలు",
      itemName: "వస్తువు పేరు",
      itemNamePlaceholder: "వస్తువు పేరు నమోదు చేయండి",
      searchItemsPlaceholder: "వస్తువులను వెతకండి...",
      category: "వర్గం",
      categoryPlaceholder: "వర్గం ఎంచుకోండి",
      quantity: "పరిమాణం",
      quantityPlaceholder: "పరిమాణం నమోదు చేయండి",
      unit: "యూనిట్",
      unitPlaceholder: "యూనిట్ నమోదు చేయండి",
      unitPrice: "మొత్తం యూనిట్ ధర",
      unitPricePlaceholder: "మొత్తం యూనిట్ ధర నమోదు చేయండి",
      batchNumber: "బ్యాచ్ నంబర్",
      batchNumberPlaceholder: "బ్యాచ్ నంబర్",
      expiryDate: "గడువు తేదీ",
      expiryDatePlaceholder: "dd--mm--yyyy",
      addMoreItems: "+ మరిన్ని వస్తువులు జోడించండి",
      totalCost: "ముడి పదార్థాల మొత్తం ఖర్చు",
      saveAsDraft: "డ్రాఫ్ట్‌గా సేవ్ చేయండి",
      submit: "సమర్పించండి",
      deleteItem: "ఈ వస్తువును తొలగించండి",
      selectShift: "షిఫ్ట్ ఎంచుకోండి",
      selectCategory: "వర్గం ఎంచుకోండి"
    },
    
    // Vendors (Telugu)
    vendors: {
      vendor: "విక్రేత"
    },
    
    // Notifications (Telugu)
    notifications: {
      title: "నోటిఫికేషన్లు",
      backToDashboard: "డాష్‌బోర్డ్‌కు తిరిగి వెళ్ళండి",
      settings: "సెట్టింగ్‌లు",
      searchPlaceholder: "నోటిఫికేషన్లను శోధించండి...",
      loading: "లోడ్ అవుతోంది...",
      noNotifications: "నోటిఫికేషన్లు లేవు",
      markAllAsRead: "✔ అన్నింటినీ చదివినట్లు గుర్తించండి",
      dismissAll: "✕ అన్నింటినీ తీసివేయండి",
      refreshAll: "↻ అన్ని నోటిఫికేషన్లను రిఫ్రెష్ చేయండి",
      viewDetails: "వివరాలను చూడండి",
      hideDetails: "వివరాలను దాచండి",
      markRead: "చదివినట్లు గుర్తించండి",
      dismiss: "తీసివేయండి",
      loadingDetails: "వివరాలు లోడ్ అవుతున్నాయి…",
      failedToLoadDetails: "వివరాలను లోడ్ చేయడంలో విఫలమైంది:",
      noDetails: "వివరాలు లేవు",
      // Notification types/tags
      inventory: "ఇన్వెంటరీ",
      stock: "స్టాక్",
      recipe: "వంటకం",
      lowStock: "తక్కువ స్టాక్",
      info: "సమాచారం",
      warning: "హెచ్చరిక",
      alert: "అలర్ట్",
      success: "విజయం",
      // Details view
      shortOn: "లోపం",
      ingredients: "పదార్థం(లు)",
      need: "అవసరం",
      have: "ఉన్నవి",
      updated: "నవీకరించబడింది",
      changed: "మార్చబడింది",
      added: "జోడించబడింది",
      removed: "తొలగించబడింది",
      from: "నుండి",
      to: "కు",
      cost: "ఖర్చు",
      // Notification Content Templates (Telugu)
      content: {
        wastageAlertTrendUp: "వ్యర్థం హెచ్చరిక: గత {{days}} రోజు(ల)లో పెరుగుదల",
        wastageAlertDesc: "మీ వ్యర్థం ఖర్చు ధోరణి గత {{days}} రోజు(ల)లో {{percent}}% పెరిగింది.",
        reminderWastageReport: "రిమైండర్: రోజువారీ వ్యర్థ రిపోర్ట్ బకాయి — {{date}}",
        reminderWastageDesc: "{{date}} కోసం మీ రోజువారీ వ్యర్థ రిపోర్ట్ సమర్పించబడలేదు. ఇన్వెంటరీ మరియు రిపోర్టులను ఖచ్చితంగా ఉంచడానికి దయచేసి వ్యర్థాన్ని రికార్డ్ చేయండి.",
        reminderStockOutReport: "రిమైండర్: రోజువారీ స్టాక్ అవుట్ రిపోర్ట్ బకాయి — {{date}}",
        reminderStockOutDesc: "{{date}} కోసం మీ రోజువారీ స్టాక్ వాడుక రిపోర్ట్ సమర్పించబడలేదు. ఇన్వెంటరీని ఖచ్చితంగా ఉంచడానికి దయచేసి అమ్మకాలు మరియు వ్యర్థాన్ని రికార్డ్ చేయండి.",
        endOfDayReportReady: "రోజు ముగింపు రిపోర్ట్ సిద్ధంగా ఉంది — {{date}}",
        endOfDayDesc: "{{date}} కోసం మీ రోజువారీ రిపోర్ట్ సిద్ధంగా ఉంది. అమ్మకాలు, వ్యర్థం, వినియోగం మరియు ఇన్వెంటరీ ప్రభావాన్ని చూడండి.",
        restocked: "తిరిగి నిల్వ చేయబడింది: {{item}}",
        restockedDesc: "{{item}} కోసం స్టాక్ ఇప్పుడు {{quantity}} {{unit}}, రీఆర్డర్/సేఫ్టీ థ్రెషోల్డ్‌ల కంటే ఎక్కువ.",
        recipeUpdated: "వంటకం నవీకరించబడింది: {{recipe}}",
        recipeUpdatedDesc: "{{recipe}} వంటకం నవీకరించబడింది. {{count}} పదార్థాలు సేవ్ చేయబడ్డాయి. అవసరమైతే పదార్థ మ్యాపింగ్ మరియు ఖర్చులను సమీక్షించండి.",
        newInventoryItem: "కొత్త ఇన్వెంటరీ వస్తువు సృష్టించబడింది: {{item}}",
        newInventoryItemDesc: "{{recipe}} వంటకాన్ని నవీకరించేటప్పుడు మేము కొత్త ఇన్వెంటరీ వస్తువు \"{{item}}\" సృష్టించాము. ప్రామాణిక యూనిట్: {{unit}}. మీరు రీఆర్డర్ పాయింట్లు, విక్రేత మరియు ABC వర్గాన్ని సెట్ చేయాలనుకోవచ్చు.",
        zeroCostRecipe: "సున్న-ఖర్చు వంటకం: {{recipe}}",
        zeroCostRecipeDesc: "{{recipe}} వంటకంలో ఖర్చు డేటా లేదు. స్టాక్ ఇన్/ఇన్వెంటరీలో ముడి పదార్థాలకు యూనిట్‌కు ఖర్చు ఉందని నిర్ధారించుకోండి.",
        unmappedIngredient: "మ్యాప్ చేయని పదార్థ యూనిట్: {{ingredient}}",
        unmappedIngredientDesc: "{{recipe}} వంటకంలోని {{ingredient}} పదార్థం \"{{recipeUnit}}\" యూనిట్‌ను ఉపయోగిస్తుంది కానీ ఇన్వెంటరీ వస్తువు \"{{inventoryUnit}}\" ఉపయోగిస్తుంది. తగ్గింపులు ఖచ్చితంగా ఉండేలా యూనిట్ మార్పిడిని జోడించండి."
      }
    },
    
    // Vendor Management (Telugu)
    vendorCategories: {
      all: "అన్నీ",
      wholesale: "హోల్‌సేల్",
      dairy: "పాల ఉత్పత్తులు",
      meat: "మాంసం",
      seafood: "సీఫుడ్",
      vegetables: "కూరగాయలు",
      fruits: "పండ్లు",
      others: "ఇతరాలు"
    },
    vendorManagement: {
      title: "విక్రేతల నిర్వహణ",
      search_placeholder: "విక్రేతలను శోధించండి...",
      total_spend: "మొత్తం ఖర్చు",
      this_period: "(ఈ కాలం)",
      total_credit_extended: "మొత్తం క్రెడిట్ పొడిగించబడింది",
      add_credit: "క్రెడిట్ జోడించండి",
      add_vendor: "విక్రేతను జోడించండి",
      no_vendors_found: "ఎంపికైన ఫిల్టర్ కోసం విక్రేతలు కనుగొనబడలేదు",
      select_all: "'అన్నీ' ఎంచుకోండి లేదా కొత్త విక్రేతను జోడించండి",
      on_time: "సమయానికి",
      quality: "నాణ్యత",
      contact: "సంప్రదించండి",
      view_details: "వివరాలు చూడండి"
    },
    
    // Stock Out (Telugu)
    stockOut: {
      usage: "వినియోగం",
      waste: "వ్యర్థం",
      reason: "కారణం",
      select_reason: "కారణం ఎంచుకోండి",
      change: "మార్చు",
      search_placeholder: "వస్తువులను వెతకండి...",
      wastage_date: "వృధా తేదీ",
      all: "అన్నీ",
      main_course: "ముఖ్య వంటకం",
      raw_items: "ముడి పదార్థాలు",
      no_wastage: "వ్యర్థం నమోదు చేయబడలేదు",
      excess_preparation: "అధిక తయారీ",
      spoilage: "చెడిపోవడం",
      expired: "గడువు ముగిసినది",
      low_stock: "తక్కువ స్టాక్",
      out_of_stock: "స్టాక్ అయిపోయింది",
      overstocked: "అధిక స్టాక్",
      adequate: "తగినంత",
      available: "అందుబాటులో",
      days_to_expiry: "గడువు ముగిసే రోజులు",
      submit: "సమర్పించండి",
      cancel: "రద్దు చేయండి",
      total_items: "మొత్తం వస్తువులు",
      estimated_waste_cost: "అంచనా వ్యర్థ ఖర్చు",
      manufacturing_cost: "తయారీ ఖర్చు"
    },
    
    // Daily Production Planning (Usage Page) - Telugu
    productionPlanning: {
      title: "రోజువారీ ఉత్పత్తి ప్రణాళిక",
      todaysRevenueForecast: "నేటి ఆదాయ అంచనా",
      itemsPlanned: "ప్రణాళిక చేసిన వస్తువులు",
      avgConfidence: "సగటు విశ్వాసం",
      smartRecommendations: "స్మార్ట్ సిఫార్సులు",
      priority: "ప్రాధాన్యత",
      high: "అధిక",
      medium: "మధ్యస్థ",
      low: "తక్కువ",
      apply: "వర్తింపజేయండి",
      dismiss: "తిరస్కరించండి",
      searchMenuItems: "మెను వస్తువులను వెతకండి...",
      saveChanges: "మార్పులను సేవ్ చేయండి",
      confirmTodaysPlan: "నేటి ప్రణాళికను నిర్ధారించండి",
      reviewPlan: "మీ ఉత్పత్తి ప్రణాళికను సమీక్షించండి",
      pleaseReview: "దయచేసి మీ పరిమాణాలను సమీక్షించడానికి ఒక క్షణం తీసుకోండి. మీకు ఉన్నాయి:",
      secondsRemaining: "సెకన్లు మిగిలి ఉన్నాయి",
      totalItems: "మొత్తం వస్తువులు",
      estimatedRevenue: "అంచనా ఆదాయం",
      modifiedItems: "సవరించిన వస్తువులు",
      confirmProductionPlan: "ఉత్పత్తి ప్రణాళికను నిర్ధారించండి",
      pleaseWaitToConfirm: "దయచేసి మీ ప్రణాళికను నిర్ధారించడానికి వేచి ఉండండి...",
      loadingPlan: "మీ ఉత్పత్తి ప్రణాళికను లోడ్ చేస్తోంది...",
      noItemsFound: "వస్తువులు కనుగొనబడలేదు",
      noItemsMatch: "వస్తువులు సరిపోలలేదు",
      tryAdjusting: "మీ శోధనను సర్దుబాటు చేయడానికి ప్రయత్నించండి.",
      noPlanForDate: "ఈ తేదీకి ఉత్పత్తి ప్రణాళిక లేదు. సిస్టమ్ మీ అమ్మకాల చరిత్ర ఆధారంగా సిఫార్సులను రూపొందిస్తుంది.",
      uncategorized: "వర్గీకరించబడలేదు",
      per: "ప్రతి",
      item: "వస్తువు",
      confidence: "విశ్వాసం",
      plannedQuantity: "ప్రణాళికాబద్ధ పరిమాణం",
      estRevenue: "అంచనా ఆదాయం",
      manual: "చేతితో",
      recentAvg: "ఇటీవలి సగటు",
      sameDayAvg: "అదే రోజు సగటు",
      modified: "సవరించబడింది"
    },
    
    // Usage Component (Production Planning Form) - Telugu
    usage: {
      productionDate: "ఉత్పత్తి తేదీ",
      allDayShift: "మొత్తం రోజు",
      morningShift: "ఉదయం షిఫ్ట్",
      afternoonShift: "మధ్యాహ్నం షిఫ్ట్",
      eveningShift: "సాయంత్రం షిఫ్ట్",
      nightShift: "రాత్రి షిఫ్ట్",
      items: "వస్తువులు",
      addItems: "వస్తువులు జోడించండి",
      addMoreItems: "మరిన్ని వస్తువులు జోడించండి",
      notes: "గమనికలు",
      notesPlaceholder: "ఇక్కడ గమనికలు జోడించండి...",
      submit: "సమర్పించండి",
      estimatedCost: "అంచనా ఖర్చు",
      confirmUsageRecord: "వినియోగ రికార్డును నిర్ధారించండి",
      totalItems: "మొత్తం వస్తువులు",
      shift: "షిఫ్ట్",
      shiftTime: "షిఫ్ట్ సమయం",
      cancel: "రద్దు చేయండి",
      confirm: "నిర్ధారించండి",
      processing: "ప్రాసెస్ చేస్తోంది...",
      successMessage: "వినియోగ డేటా విజయవంతంగా సమర్పించబడింది!",
      pleaseAddItems: "దయచేసి సమర్పించడానికి ముందు కనీసం ఒక వస్తువును జోడించండి.",
      invalidQuantities: "కొన్ని వస్తువులు చెల్లని పరిమాణాలను కలిగి ఉన్నాయి. దయచేసి తనిఖీ చేసి మళ్లీ ప్రయత్నించండి.",
      plates: "ప్లేట్లు",
      searchItems: "వస్తువులను వెతకండి..."
    },
    
    // Waste Component (Waste Recording Form) - Telugu
    waste: {
      selectWasteReason: "వ్యర్థ కారణాన్ని ఎంచుకోండి",
      selectStaffMember: "సిబ్బంది సభ్యుడిని ఎంచుకోండి",
      confirmWasteRecord: "వ్యర్థ రికార్డును నిర్ధారించండి",
      totalItems: "మొత్తం వస్తువులు",
      estimatedWasteCost: "అంచనా వ్యర్థ ఖర్చు",
      reason: "కారణం",
      recordedBy: "రికార్డ్ చేసినవారు",
      cancel: "రద్దు చేయండి",
      confirm: "నిర్ధారించండి",
      processing: "ప్రాసెస్ చేస్తోంది...",
      photoRequired: "📸 ఫోటో అవసరం",
      confirmWaste: "వ్యర్థాన్ని నిర్ధారించండి",
      photoEvidenceRequired: "ఫోటో అవసరం",
      highValueWasteDetected: "అధిక-విలువ వ్యర్థం గుర్తించబడింది",
      addPhotoInstruction: "ఈ వ్యర్థ రికార్డును నిర్ధారించే ముందు దయచేసి కనీసం ఒక ఫోటోను జోడించండి.",
      howToAddPhoto: "ఫోటో ఎలా జోడించాలి:",
      clickCameraIcon: "ఫోటో తీయండి",
      captureMultiplePhotos: "మెరుగైన డాక్యుమెంటేషన్ కోసం మీరు అనేక ఫోటోలను తీయవచ్చు",
      goBack: "వెనక్కి వెళ్ళండి",
      proceedWithoutPhoto: "ఫోటో లేకుండా కొనసాగండి",
      successMessage: "వ్యర్థ రికార్డు విజయవంతంగా సమర్పించబడింది!"
    },
    
    // Settings Page (Telugu)
    settings: {
      title: "సెట్టింగ్‌లు",
      page_title: "సెట్టింగ్‌లు",
      financials_profitability: "ఆర్థిక అంశాలు & లాభదాయకత",
      net_profit_analyzer: "నికర లాభాల విశ్లేషణ",
      simulate_profitability: "నెలవారీ లాభదాయకత మరియు ముగింపు దృశ్యాలను అనుకరించండి",
      search_settings: "సెట్టింగ్‌లను శోధించండి...",
      
      // Notification Preferences
      notification_preferences: "నోటిఫికేషన్ ప్రాధాన్యతలు",
      critical_stock_alerts: "క్లిష్ట స్టాక్ హెచ్చరికలు",
      high_value_transactions: "అధిక-విలువ లావాదేవీలు",
      
      // Account Management Section
      account_management: "ఖాతా నిర్వహణ",
      my_profile: "నా ప్రొఫైల్",
      view_edit_profile: "మీ ప్రొఫైల్‌ను చూడండి మరియు సవరించండి",
      change_password: "పాస్‌వర్డ్ మార్చండి",
      update_account_security: "మీ ఖాతా భద్రతను నవీకరించండి",
      app_language: "యాప్ భాష",
      sign_out: "సైన్ అవుట్",
      logout_account: "మీ ఖాతా నుండి లాగౌట్ అవ్వండి",
      
      // Edit Profile Modal
      edit_profile: "ప్రొఫైల్ సవరించండి",
      full_name: "పూర్తి పేరు",
      email_address: "ఇమెయిల్ చిరునామా",
      phone_number: "ఫోన్ నంబర్",
      save_changes: "మార్పులను సేవ్ చేయండి",
      cancel: "రద్దు చేయండి",
      
      // Change Password Modal
      current_password: "ప్రస్తుత పాస్‌వర్డ్",
      new_password: "కొత్త పాస్‌వర్డ్",
      confirm_new_password: "కొత్త పాస్‌వర్డ్‌ను నిర్ధారించండి",
      password_requirements: "పాస్‌వర్డ్ కనీసం 8 అక్షరాలు ఉండాలి",
      update_password: "పాస్‌వర్డ్‌ను నవీకరించండి",
      
      // Language Modal
      select_language: "భాషను ఎంచుకోండి",
      english: "English",
      telugu: "తెలుగు",
      hindi: "हिंदी",
      
      // Business & Location
      business_profile: "రెస్టారెంట్ ప్రొఫైల్",
      business_details: "వ్యాపార పేరు, చిరునామా, సంప్రదింపు వివరాలు",
      manage_locations: "లొకేషన్‌లను నిర్వహించండి",
      active_branches: "క్రియాశీల శాఖలు",
      operating_hours: "పనిచేసే గంటలు",
      configure_shifts: "వ్యాపార షిఫ్ట్‌లను కాన్ఫిగర్ చేయండి",
      
      // Inventory Management
      inventory_management: "ఇన్వెంటరీ నిర్వహణ",
      units_of_measure: "కొలత యూనిట్లు",
      manage_units: "KG, L, ముక్కలు, ప్లేట్లు నిర్వహించండి",
      reorder_defaults: "రీఆర్డర్ పాయింట్ డిఫాల్ట్‌లు",
      automatic_reorder: "ఆటోమేటిక్ రీఆర్డర్ నియమాలను సెట్ చేయండి",
      inventory_categories: "ఇన్వెంటరీ వర్గాలు",
      category_types: "ఉత్పత్తులు, డెయిరీ, మాంసం, పొడి వస్తువులు",
      
      // Sales & Menu Management
      sales_menu: "అమ్మకాలు & మెనూ నిర్వహణ",
      menu_categories: "మెనూ వర్గాలు",
      menu_types: "అల్పాహారం, భోజనం, పానీయాలు",
      tax_rates: "పన్ను రేట్లు",
      tax_config: "GST/VAT కాన్ఫిగరేషన్",
      payment_methods: "చెల్లింపు పద్ధతులు",
      payment_types: "నగదు, UPI, కార్డ్, వాలెట్‌లు",
      localized_pricing: "స్థానిక ధర నిర్ణయం",
      branch_pricing: "శాఖ-నిర్దిష్ట ధరలను అనుమతించండి",
      
      // Vendor & Procurement
      vendor_procurement: "విక్రేత & సేకరణ",
      manage_vendors: "విక్రేతలను నిర్వహించండి",
      active_suppliers: "క్రియాశీల సరఫరాదారులు",
      payment_terms: "డిఫాల్ట్ చెల్లింపు నిబంధనలు",
      net_days: "నెట్ రోజులు",
      
      // Wastage & Production
      wastage_production: "వ్యర్థం & ఉత్పత్తి",
      wastage_reasons: "వ్యర్థం కారణాలు",
      wastage_types: "గడువు ముగిసినది, చిందుడు, అధికంగా వండినది",
      yield_tolerances: "ఉత్పత్తి దిగుబడి సహనం",
      deviation_alert: "విచలనం వద్ద హెచ్చరిక",
      
      // App Information & Support
      app_info_support: "యాప్ సమాచారం & మద్దతు",
      help_support: "సహాయం & మద్దతు",
      help_resources: "FAQ, సంప్రదించండి, ట్యుటోరియల్స్",
      about_app: "ఇన్వెక్సిస్ గురించి",
      app_version: "వెర్షన్ 1.2.3",
      
      // Common
      save: "సేవ్ చేయండి",
      close: "మూసివేయండి",
      add: "జోడించండి",
      edit: "సవరించండి",
      delete: "తొలగించండి",
      search: "శోధించండి",
      clear: "క్లియర్ చేయండి",
      apply: "వర్తింపజేయండి",
      reset: "రీసెట్ చేయండి"
    },
    
    // Sidebar/User Management (Telugu)
    sidebar: {
      user_access_management: "వినియోగదారు & యాక్సెస్ నిర్వహణ",
      invite_new_user: "కొత్త వినియోగదారుని ఆహ్వానించండి",
      send_invitation: "కొత్త టీమ్ సభ్యునికి ఆహ్వానం పంపండి",
      manage_users: "వినియోగదారులను నిర్వహించండి",
      total_users: "మొత్తం వినియోగదారులు",
      active: "క్రియాశీలం",
      roles_permissions: "పాత్రలు & అనుమతులు",
      roles_configured: "పాత్రలు కాన్ఫిగర్ చేయబడ్డాయి",
      location_assignment: "లొకేషన్ కేటాయింపు",
      assign_users: "నిర్దిష్ట లొకేషన్‌లకు వినియోగదారులను కేటాయించండి",
      two_factor_authentication: "రెండు-కారక ప్రామాణీకరణ",
      enhanced_security: "అన్ని ఖాతాల కోసం మెరుగైన భద్రత",
      activity_logs: "కార్యాచరణ లాగ్‌లు",
      view_user_actions: "వినియోగదారు చర్యలు మరియు మార్పులను చూడండి",
      business_location_management: "వ్యాపారం & లొకేషన్ నిర్వహణ",
      
      // Invite User Form
      name: "పేరు",
      email: "ఇమెయిల్",
      phone: "ఫోన్",
      role: "పాత్ర",
      select_role: "పాత్రను ఎంచుకోండి",
      locations: "లొకేషన్‌లు",
      select_locations: "లొకేషన్‌లను ఎంచుకోండి",
      send_invite: "ఆహ్వానం పంపండి",
      
      // User Management
      user_list: "వినియోగదారు జాబితా",
      status: "స్థితి",
      last_active: "చివరిగా క్రియాశీలంగా ఉంది",
      actions: "చర్యలు",
      deactivate: "నిష్క్రియం చేయండి",
      activate: "క్రియాశీలం చేయండి",
      edit_user: "వినియోగదారుని సవరించండి",
      delete_user: "వినియోగదారుని తొలగించండి"
    },
    
    // Waste Reason Labels (Database translations) - Telugu
    wasteReasons: {
      "Pest Contamination": "పురుగుల కలుషితం",
      "Quality Control Rejection": "నాణ్యత నియంత్రణ తిరస్కరణ",
      "Spoilage - Damaged": "పాడైపోవడం - దెబ్బతిన్నది",
      "Spoilage - Expired": "పాడైపోవడం - గడువు ముగిసింది",
      "Storage Issue": "నిల్వ సమస్య",
      "Temperature Control Failure": "ఉష్ణోగ్రత నియంత్రణ వైఫల్యం",
      "Customer Return - Complaint": "కస్టమర్ రిటర్న్ - ఫిర్యాదు",
      "Kitchen Mistake": "వంటగది పొరపాటు",
      "Over-production": "అధిక ఉత్పత్తి",
      "Under-production Waste": "తక్కువ ఉత్పత్తి వ్యర్థం",
      "Equipment Failure": "పరికరాల వైఫల్యం",
      "Staff Training Error": "సిబ్బంది శిక్షణ లోపం",
      "billing errors": "బిల్లింగ్ లోపాలు",
      "spillage": "చిందడం",
      "spoilage": "పాడైపోవడం",
      "Overcooked": "అధికంగా వండినది",
      "Customer Return": "కస్టమర్ రిటర్న్",
      "Preparation Error": "తయారీ లోపం",
      "Spoilage (Prepared)": "పాడైపోవడం (తయారైనది)",
      "Excess Preparation": "అదనపు తయారీ",
      "No wastage recorded": "వ్యర్థం రికార్డ్ చేయబడలేదు",
      "Ingredient Waste": "పదార్థ వ్యర్థం",
      "Dish Waste": "వంటకం వ్యర్థం",
      "General Waste": "సాధారణ వ్యర్థం",
      "Food Preparation": "ఆహార తయారీ",
      "Service Issue": "సేవా సమస్య",
      "Food Quality": "ఆహార నాణ్యత",
      "Inventory Management": "ఇన్వెంటరీ నిర్వహణ",
      "Administrative": "పరిపాలనా",
      "No Waste": "వ్యర్థం లేదు"
    }
  },
  
  hi: {
    // Report Screen (Hindi)
    reports: {
      title: "रिपोर्ट",
      salesReports: "बिक्री रिपोर्ट",
      today: "आज",
      thisWeek: "इस सप्ताह",
      thisMonth: "इस महीने",
      thisYear: "इस वर्ष",
      totalSales: "कुल बिक्री",
      grossProfit: "सकल लाभ",
      expense: "खर्च",
      topItemsTitle: "सकल लाभ योगदान द्वारा शीर्ष 5 वस्तुएं",
      grossProfitVsCogs: "सकल लाभ बनाम विनिर्माण लागत वितरण",
      noDataAvailable: "आज के लिए लाभ डेटा उपलब्ध नहीं है",
      noSalesData: "इस अवधि के लिए बिक्री डेटा उपलब्ध नहीं है",
      dailyContribution: "दैनिक योगदान",
      weeklyContribution: "साप्ताहिक योगदान",
      monthlyContribution: "मासिक योगदान",
      yearlyContribution: "वार्षिक योगदान",
      clickToSetBep: "BEP लक्ष्य सेट करने के लिए क्लिक करें",
      // Stock Report Labels (Hindi)
      before: "पहले",
      after: "बाद में",
      deducted: "घटाया गया",
      wasted: "बर्बाद किया",
      searchMaterials: "सामग्री खोजें",
      lowStock: "कम स्टॉक",
      sufficient: "पर्याप्त",
      keyInsights: "मुख्य जानकारी",
      bestSellingItem: "सबसे ज्यादा बिकने वाली वस्तु",
      mostWastedItem: "सबसे ज्यादा बर्बाद वस्तु",
      rawMaterialStockReport: "कच्चे माल का स्टॉक रिपोर्ट",
      sales: {
        title: "बिक्री रिपोर्ट",
        dailySummary: {
          title: "दैनिक बिक्री सारांश",
          subtitle: "दैनिक राजस्व और लेनदेन का अवलोकन"
        },
        saleTrend: {
          title: "बिक्री प्रवृत्ति",
          subtitle: "सकल लाभ बनाम COGS वितरण"
        },
        topItems: {
          title: "राजस्व के अनुसार शीर्ष वस्तुएं",
          subtitle: "दिन भर बिक्री वितरण"
        },
        onlineOrders: {
          title: "ऑनलाइन ऑर्डर",
          subtitle: "ऑनलाइन चैनलों से ऑर्डर ट्रैक करें"
        }
      },
      stock: {
        title: "स्टॉक रिपोर्ट",
        itemWise: {
          title: "वस्तु-वार बिक्री रिपोर्ट",
          subtitle: "तत्काल पुनःस्टॉक की आवश्यकता वाली वस्तुएं"
        },
        rawMaterial: {
          title: "कच्चा माल स्टॉक रिपोर्ट",
          subtitle: "वर्तमान स्टॉक मूल्य और मूल्यांकन"
        },
        usage: {
          title: "अनुमानित बनाम वास्तविक समय उपयोग",
          subtitle: "उपभोग पैटर्न और रुझान",
          menuItem: "मेनू आइटम",
          estimated: "अनुमानित",
          actualPlates: "वास्तविक प्लेटें",
          variance: "विचलन",
          plates: "प्लेटें",
          noDataAvailable: "चयनित अवधि के लिए कोई डेटा उपलब्ध नहीं है"
        }
      },
      online: {
        title: "ऑनलाइन ऑर्डर"
      },
      wastage: {
        title: "बर्बादी रिपोर्ट",
        comparison: {
          title: "बर्बादी तुलना",
          subtitle: "दैनिक खाद्य अपशिष्ट ट्रैकिंग"
        }
      }
    },
    
    // Inventory Screen (Hindi)
    inventory: {
      title: "इन्वेंटरी अवलोकन",
      overview: "अवलोकन",
      stock_in: "स्टॉक इन",
      stock_out: "स्टॉक आउट",
      categories: "श्रेणियां",
      allItems: "सभी वस्तुएं",
      lowStock: "कम स्टॉक",
      outOfStock: "स्टॉक खत्म",
      expiringSoon: "जल्द समाप्त हो रहा है",
      searchPlaceholder: "वस्तुएं खोजें...",
      search_placeholder: "वस्तुएं खोजें...",
      itemName: "वस्तु का नाम",
      quantity: "मात्रा",
      category: "श्रेणी",
      status: "स्थिति",
      expiryDate: "समाप्ति तिथि",
      supplier: "आपूर्तिकर्ता",
      lastUpdated: "अंतिम अपडेट",
      noItemsFound: "कोई वस्तु नहीं मिली",
      no_items_found: "कोई वस्तु नहीं मिली",
      no_inventory_items: "अभी तक कोई इन्वेंटरी वस्तु नहीं",
      add_items_hint: "के माध्यम से वस्तुएं जोड़ें",
      tab_to_see: "टैब उन्हें यहां देखने के लिए",
      go_to_stock_in: "स्टॉक इन पर जाएं",
      filters: "फ़िल्टर",
      sortBy: "क्रमबद्ध करें",
      filter_expiry_nearest: "समाप्ति (निकटतम पहले)",
      filter_newly_added: "नया जोड़ा गया",
      filter_cost_high_low: "लागत (उच्च से निम्न)",
      filter_cost_low_high: "लागत (निम्न से उच्च)",
      filter_quantity_high_low: "मात्रा (उच्च से निम्न)",
      filter_quantity_low_high: "मात्रा (निम्न से उच्च)",
      filter_category: "श्रेणी के अनुसार",
      filter_saved_prep: "सेव्ड प्रेप",
      filter_not_associated: "असंबद्ध",
      filter_non_consumable: "नॉन-कंज़्यूमेबल",
      data_as_of: "डेटा की तारीख",
      failed_to_load: "इन्वेंटरी डेटा लोड करने में विफल",
      reconcile_stock: "स्टॉक का मिलान करें",
      fix: "ठीक करें",
      expired: "समाप्त हो गया",
      expires_today: "आज समाप्त हो रहा है",
      expires_tomorrow: "कल समाप्त हो रहा है",
      expires_in_days: "{{days}} दिनों में समाप्त हो रहा है",
      fresh: "ताजा",
      no_expiry: "कोई समाप्ति नहीं",
      good: "अच्छा",
      fifo_batch_details: "FIFO बैच विवरण",
      failed_batch_details: "बैच विवरण लोड करने में विफल",
      no_batch_details: "कोई बैच विवरण उपलब्ध नहीं",
      use_first: "पहले उपयोग करें",
      current: "वर्तमान",
      rop: "ROP",
      safety: "सुरक्षा",
      critical: "महत्वपूर्ण",
      low: "कम",
      minimal_stock: "न्यूनतम स्टॉक",
      no_low_stock_items: "अभी कोई कम स्टॉक आइटम नहीं हैं।"
    },
    
    // Common UI (Hindi)
    common: {
      search: "खोजें",
      filter: "फ़िल्टर",
      back: "वापस",
      next: "अगला",
      save: "सहेजें",
      cancel: "रद्द करें",
      delete: "हटाएं",
      edit: "संपादित करें",
      add: "जोड़ें",
      update: "अपडेट करें",
      loading: "लोड हो रहा है...",
      error: "त्रुटि",
      success: "सफलता",
      home: "होम",
      settings: "सेटिंग्स",
      logout: "लॉगआउट",
      retry: "पुनः प्रयास करें",
      retrying: "पुनः प्रयास कर रहा है...",
      allTime: "सभी समय",
      refresh: "रीफ्रेश करें"
    },
    
    // Reorder/Procurement (Hindi)
    reorder: {
      title: "पुनः ऑर्डर बनाएं",
      create_reorder: "पुनः ऑर्डर बनाएं",
      suggestedItems: "सुझाई गई वस्तुएं",
      itemName: "वस्तु का नाम",
      currentStock: "वर्तमान स्टॉक",
      reorderPoint: "पुनः ऑर्डर बिंदु",
      recommendedQty: "अनुशंसित मात्रा",
      vendor: "विक्रेता",
      estimatedCost: "अनुमानित लागत",
      createPO: "खरीद ऑर्डर बनाएं",
      addToCart: "कार्ट में जोड़ें"
    },
    
    // Stock-In Manual Entry (Hindi)
    stockIn: {
      title: "स्टॉक इन - मैनुअल एंट्री",
      scanBill: "बिल स्कैन करें",
      manualEntry: "मैनुअल एंट्री",
      vendorName: "विक्रेता का नाम",
      vendorNamePlaceholder: "बिल से विक्रेता का नाम",
      phoneNumber: "फोन नंबर",
      phonePlaceholder: "विक्रेता फोन (यदि उपलब्ध हो)",
      productionDate: "उत्पादन तिथि",
      shift: "शिफ्ट",
      morning: "सुबह",
      evening: "शाम",
      items: "खरीद",
      itemName: "वस्तु का नाम",
      itemNamePlaceholder: "वस्तु का नाम दर्ज करें",
      searchItemsPlaceholder: "वस्तुएं खोजें...",
      category: "श्रेणी",
      categoryPlaceholder: "श्रेणी चुनें",
      quantity: "मात्रा",
      quantityPlaceholder: "मात्रा दर्ज करें",
      unit: "इकाई",
      unitPlaceholder: "इकाई दर्ज करें",
      unitPrice: "कुल इकाई मूल्य",
      unitPricePlaceholder: "कुल इकाई मूल्य दर्ज करें",
      batchNumber: "बैच नंबर",
      batchNumberPlaceholder: "बैच नंबर",
      expiryDate: "समाप्ति तिथि",
      expiryDatePlaceholder: "dd--mm--yyyy",
      addMoreItems: "+ और वस्तुएं जोड़ें",
      totalCost: "कच्चे माल की कुल लागत",
      saveAsDraft: "ड्राफ्ट के रूप में सहेजें",
      submit: "जमा करें",
      deleteItem: "इस वस्तु को हटाएं",
      selectShift: "शिफ्ट चुनें",
      selectCategory: "श्रेणी चुनें"
    },
    
    // Vendors (Hindi)
    vendors: {
      vendor: "विक्रेता"
    },
    
    // Notifications (Hindi)
    notifications: {
      title: "सूचनाएं",
      backToDashboard: "डैशबोर्ड पर वापस जाएं",
      settings: "सेटिंग्स",
      searchPlaceholder: "सूचनाएं खोजें...",
      loading: "लोड हो रहा है...",
      noNotifications: "कोई सूचना नहीं",
      markAllAsRead: "✔ सभी को पढ़ा हुआ चिह्नित करें",
      dismissAll: "✕ सभी को खारिज करें",
      refreshAll: "↻ सभी सूचनाएं रीफ्रेश करें",
      viewDetails: "विवरण देखें",
      hideDetails: "विवरण छुपाएं",
      markRead: "पढ़ा हुआ चिह्नित करें",
      dismiss: "खारिज करें",
      loadingDetails: "विवरण लोड हो रहे हैं…",
      failedToLoadDetails: "विवरण लोड करने में विफल:",
      noDetails: "कोई विवरण नहीं",
      // Notification types/tags
      inventory: "इन्वेंटरी",
      stock: "स्टॉक",
      recipe: "रेसिपी",
      lowStock: "कम स्टॉक",
      info: "जानकारी",
      warning: "चेतावनी",
      alert: "अलर्ट",
      success: "सफलता",
      // Details view
      shortOn: "की कमी",
      ingredients: "सामग्री",
      need: "आवश्यक",
      have: "उपलब्ध",
      updated: "अपडेट किया गया",
      changed: "बदला गया",
      added: "जोड़ा गया",
      removed: "हटाया गया",
      from: "से",
      to: "तक",
      cost: "लागत",
      // Notification Content Templates (Hindi)
      content: {
        wastageAlertTrendUp: "अपशिष्ट अलर्ट: पिछले {{days}} दिन(ों) में वृद्धि",
        wastageAlertDesc: "आपकी अपशिष्ट लागत प्रवृत्ति पिछले {{days}} दिन(ों) में {{percent}}% बढ़ी है।",
        reminderWastageReport: "अनुस्मारक: दैनिक अपशिष्ट रिपोर्ट बकाया — {{date}}",
        reminderWastageDesc: "{{date}} के लिए आपकी दैनिक अपशिष्ट रिपोर्ट जमा नहीं की गई है। कृपया इन्वेंटरी और रिपोर्ट को सटीक रखने के लिए अपशिष्ट रिकॉर्ड करें।",
        reminderStockOutReport: "अनुस्मारक: दैनिक स्टॉक आउट रिपोर्ट बकाया — {{date}}",
        reminderStockOutDesc: "{{date}} के लिए आपकी दैनिक स्टॉक उपयोग रिपोर्ट जमा नहीं की गई है। कृपया इन्वेंटरी को सटीक रखने के लिए बिक्री और अपशिष्ट रिकॉर्ड करें।",
        endOfDayReportReady: "दिन की समाप्ति रिपोर्ट तैयार — {{date}}",
        endOfDayDesc: "{{date}} के लिए आपकी दैनिक रिपोर्ट तैयार है। बिक्री, अपशिष्ट, उपयोग और इन्वेंटरी प्रभाव देखें।",
        restocked: "पुनः स्टॉक किया गया: {{item}}",
        restockedDesc: "{{item}} के लिए स्टॉक अब {{quantity}} {{unit}} है, पुनः ऑर्डर/सुरक्षा सीमा से ऊपर।",
        recipeUpdated: "रेसिपी अपडेट की गई: {{recipe}}",
        recipeUpdatedDesc: "{{recipe}} की रेसिपी अपडेट की गई। {{count}} सामग्री सहेजी गई। यदि आवश्यक हो तो सामग्री मैपिंग और लागत की समीक्षा करें।",
        newInventoryItem: "नई इन्वेंटरी वस्तु बनाई गई: {{item}}",
        newInventoryItemDesc: "{{recipe}} रेसिपी को अपडेट करते समय हमने एक नई इन्वेंटरी वस्तु \"{{item}}\" बनाई। मानक इकाई: {{unit}}। आप पुनः ऑर्डर बिंदु, विक्रेता और ABC श्रेणी सेट करना चाह सकते हैं।",
        zeroCostRecipe: "शून्य-लागत रेसिपी: {{recipe}}",
        zeroCostRecipeDesc: "{{recipe}} रेसिपी में कोई लागत डेटा नहीं है। सुनिश्चित करें कि कच्चे माल में स्टॉक इन/इन्वेंटरी में प्रति इकाई लागत है।",
        unmappedIngredient: "अनमैप्ड सामग्री इकाई: {{ingredient}}",
        unmappedIngredientDesc: "{{recipe}} रेसिपी में {{ingredient}} सामग्री \"{{recipeUnit}}\" इकाई का उपयोग करती है लेकिन इन्वेंटरी वस्तु \"{{inventoryUnit}}\" का उपयोग करती है। कटौती सटीक होने के लिए इकाई रूपांतरण जोड़ें।"
      }
    },
    
    // Vendor Management (Hindi)
    vendorCategories: {
      all: "सभी",
      wholesale: "थोक",
      dairy: "डेयरी",
      meat: "मांस",
      seafood: "सीफूड",
      vegetables: "सब्जियां",
      fruits: "फल",
      others: "अन्य"
    },
    vendorManagement: {
      title: "विक्रेता प्रबंधन",
      search_placeholder: "विक्रेताओं को खोजें...",
      total_spend: "कुल खर्च",
      this_period: "(यह अवधि)",
      total_credit_extended: "कुल क्रेडिट विस्तारित",
      add_credit: "क्रेडिट जोड़ें",
      add_vendor: "विक्रेता जोड़ें",
      no_vendors_found: "चयनित फ़िल्टर के लिए कोई विक्रेता नहीं मिला",
      select_all: "'सभी' चुनें या नया विक्रेता जोड़ें",
      on_time: "समय पर",
      quality: "गुणवत्ता",
      contact: "संपर्क करें",
      view_details: "विवरण देखें"
    },
    
    // Stock Out (Hindi)
    stockOut: {
      usage: "उपयोग",
      waste: "बर्बादी",
      reason: "कारण",
      select_reason: "कारण चुनें",
      change: "बदलें",
      search_placeholder: "वस्तुएं खोजें...",
      wastage_date: "अपव्यय तिथि",
      all: "सभी",
      main_course: "मुख्य पकवान",
      raw_items: "कच्चा माल",
      no_wastage: "कोई बर्बादी दर्ज नहीं",
      excess_preparation: "अत्यधिक तैयारी",
      spoilage: "खराब होना",
      expired: "समाप्त",
      low_stock: "कम स्टॉक",
      out_of_stock: "स्टॉक खत्म",
      overstocked: "अधिक स्टॉक",
      adequate: "पर्याप्त",
      available: "उपलब्ध",
      days_to_expiry: "समाप्ति तक दिन",
      submit: "जमा करें",
      cancel: "रद्द करें",
      total_items: "कुल वस्तुएं",
      estimated_waste_cost: "अनुमानित बर्बादी लागत",
      manufacturing_cost: "विनिर्माण लागत"
    },
    
    // Daily Production Planning (Usage Page) - Hindi
    productionPlanning: {
      title: "दैनिक उत्पादन योजना",
      todaysRevenueForecast: "आज का राजस्व पूर्वानुमान",
      itemsPlanned: "नियोजित वस्तुएं",
      avgConfidence: "औसत विश्वास",
      smartRecommendations: "स्मार्ट सिफारिशें",
      priority: "प्राथमिकता",
      high: "उच्च",
      medium: "मध्यम",
      low: "निम्न",
      apply: "लागू करें",
      dismiss: "खारिज करें",
      searchMenuItems: "मेनू आइटम खोजें...",
      saveChanges: "परिवर्तन सहेजें",
      confirmTodaysPlan: "आज की योजना की पुष्टि करें",
      reviewPlan: "अपनी उत्पादन योजना की समीक्षा करें",
      pleaseReview: "कृपया अपनी मात्रा की समीक्षा करने के लिए एक क्षण लें। आपके पास है:",
      secondsRemaining: "सेकंड शेष",
      totalItems: "कुल वस्तुएं",
      estimatedRevenue: "अनुमानित राजस्व",
      modifiedItems: "संशोधित वस्तुएं",
      confirmProductionPlan: "उत्पादन योजना की पुष्टि करें",
      pleaseWaitToConfirm: "कृपया अपनी योजना की पुष्टि करने के लिए प्रतीक्षा करें...",
      loadingPlan: "आपकी उत्पादन योजना लोड हो रही है...",
      noItemsFound: "कोई वस्तु नहीं मिली",
      noItemsMatch: "कोई वस्तु मेल नहीं खाती",
      tryAdjusting: "अपनी खोज को समायोजित करने का प्रयास करें।",
      noPlanForDate: "इस तारीख के लिए कोई उत्पादन योजना नहीं। सिस्टम आपके बिक्री इतिहास के आधार पर सिफारिशें उत्पन्न करेगा।",
      uncategorized: "अवर्गीकृत",
      per: "प्रति",
      item: "वस्तु",
      confidence: "विश्वास",
      plannedQuantity: "नियोजित मात्रा",
      estRevenue: "अनुमानित राजस्व",
      manual: "मैनुअल",
      recentAvg: "हालिया औसत",
      sameDayAvg: "समान दिन औसत",
      modified: "संशोधित"
    },
    
    // Usage Component (Production Planning Form) - Hindi
    usage: {
      productionDate: "उत्पादन तिथि",
      allDayShift: "पूरा दिन",
      morningShift: "सुबह की शिफ्ट",
      afternoonShift: "दोपहर की शिफ्ट",
      eveningShift: "शाम की शिफ्ट",
      nightShift: "रात की शिफ्ट",
      items: "वस्तुएं",
      addItems: "वस्तुएं जोड़ें",
      addMoreItems: "और वस्तुएं जोड़ें",
      notes: "नोट्स",
      notesPlaceholder: "यहाँ नोट्स जोड़ें...",
      submit: "जमा करें",
      estimatedCost: "अनुमानित लागत",
      confirmUsageRecord: "उपयोग रिकॉर्ड की पुष्टि करें",
      totalItems: "कुल वस्तुएं",
      shift: "शिफ्ट",
      shiftTime: "शिफ्ट समय",
      cancel: "रद्द करें",
      confirm: "पुष्टि करें",
      processing: "प्रोसेसिंग...",
      successMessage: "उपयोग डेटा सफलतापूर्वक जमा किया गया!",
      pleaseAddItems: "कृपया जमा करने से पहले कम से कम एक वस्तु जोड़ें।",
      invalidQuantities: "कुछ वस्तुओं में अमान्य मात्राएं हैं। कृपया जांचें और पुनः प्रयास करें।",
      plates: "प्लेट्स",
      searchItems: "वस्तुएं खोजें..."
    },
    
    // Waste Component (Waste Recording Form) - Hindi
    waste: {
      selectWasteReason: "अपशिष्ट कारण चुनें",
      selectStaffMember: "स्टाफ सदस्य चुनें",
      confirmWasteRecord: "अपशिष्ट रिकॉर्ड की पुष्टि करें",
      totalItems: "कुल वस्तुएं",
      estimatedWasteCost: "अनुमानित अपशिष्ट लागत",
      reason: "कारण",
      recordedBy: "द्वारा रिकॉर्ड किया गया",
      cancel: "रद्द करें",
      confirm: "पुष्टि करें",
      processing: "प्रोसेसिंग...",
      photoRequired: "📸 फोटो आवश्यक",
      confirmWaste: "अपशिष्ट की पुष्टि करें",
      photoEvidenceRequired: "फोटो आवश्यक",
      highValueWasteDetected: "उच्च-मूल्य अपशिष्ट का पता चला",
      addPhotoInstruction: "कृपया इस अपशिष्ट रिकॉर्ड की पुष्टि करने से पहले कम से कम एक फोटो जोड़ें।",
      howToAddPhoto: "फोटो कैसे जोड़ें:",
      clickCameraIcon: "फोटो लें",
      captureMultiplePhotos: "बेहतर दस्तावेज़ीकरण के लिए आप कई फोटो कैप्चर कर सकते हैं",
      goBack: "वापस जाएं",
      proceedWithoutPhoto: "फोटो के बिना आगे बढ़ें",
      successMessage: "अपशिष्ट रिकॉर्ड सफलतापूर्वक जमा किया गया!"
    },
    
    // Settings Page (Hindi)
    settings: {
      title: "सेटिंग्स",
      page_title: "सेटिंग्स",
      financials_profitability: "वित्तीय और लाभप्रदता",
      net_profit_analyzer: "शुद्ध लाभ विश्लेषक",
      simulate_profitability: "माह-अंत लाभप्रदता और क्लोज परिदृश्यों का अनुकरण करें",
      search_settings: "सेटिंग्स खोजें...",
      
      // Notification Preferences
      notification_preferences: "सूचना प्राथमिकताएं",
      critical_stock_alerts: "महत्वपूर्ण स्टॉक अलर्ट",
      high_value_transactions: "उच्च-मूल्य लेनदेन",
      
      // Account Management Section
      account_management: "खाता प्रबंधन",
      my_profile: "मेरा प्रोफ़ाइल",
      view_edit_profile: "अपनी प्रोफ़ाइल देखें और संपादित करें",
      change_password: "पासवर्ड बदलें",
      update_account_security: "अपने खाते की सुरक्षा अपडेट करें",
      app_language: "ऐप भाषा",
      sign_out: "साइन आउट",
      logout_account: "अपने खाते से लॉगआउट करें",
      
      // Edit Profile Modal
      edit_profile: "प्रोफ़ाइल संपादित करें",
      full_name: "पूरा नाम",
      email_address: "ईमेल पता",
      phone_number: "फ़ोन नंबर",
      save_changes: "परिवर्तन सहेजें",
      cancel: "रद्द करें",
      
      // Change Password Modal
      current_password: "वर्तमान पासवर्ड",
      new_password: "नया पासवर्ड",
      confirm_new_password: "नए पासवर्ड की पुष्टि करें",
      password_requirements: "पासवर्ड कम से कम 8 अक्षरों का होना चाहिए",
      update_password: "पासवर्ड अपडेट करें",
      
      // Language Modal
      select_language: "भाषा चुनें",
      english: "English",
      telugu: "తెలుగు",
      hindi: "हिंदी",
      
      // Business & Location
      business_profile: "रेस्टोरेंट प्रोफ़ाइल",
      business_details: "व्यवसाय का नाम, पता, संपर्क विवरण",
      manage_locations: "स्थान प्रबंधित करें",
      active_branches: "सक्रिय शाखाएं",
      operating_hours: "संचालन घंटे",
      configure_shifts: "व्यवसाय शिफ्ट कॉन्फ़िगर करें",
      
      // Inventory Management
      inventory_management: "इन्वेंटरी प्रबंधन",
      units_of_measure: "माप की इकाइयाँ",
      manage_units: "KG, L, टुकड़े, प्लेटें प्रबंधित करें",
      reorder_defaults: "रीऑर्डर पॉइंट डिफ़ॉल्ट",
      automatic_reorder: "स्वचालित रीऑर्डर नियम सेट करें",
      inventory_categories: "इन्वेंटरी श्रेणियाँ",
      category_types: "उत्पाद, डेयरी, मांस, सूखे सामान",
      
      // Sales & Menu Management
      sales_menu: "बिक्री और मेनू प्रबंधन",
      menu_categories: "मेनू श्रेणियाँ",
      menu_types: "नाश्ता, दोपहर का भोजन, पेय",
      tax_rates: "कर दरें",
      tax_config: "GST/VAT कॉन्फ़िगरेशन",
      payment_methods: "भुगतान विधियाँ",
      payment_types: "नकद, UPI, कार्ड, वॉलेट",
      localized_pricing: "स्थानीय मूल्य निर्धारण",
      branch_pricing: "शाखा-विशिष्ट मूल्य निर्धारण की अनुमति दें",
      
      // Vendor & Procurement
      vendor_procurement: "विक्रेता और खरीद",
      manage_vendors: "विक्रेताओं का प्रबंधन करें",
      active_suppliers: "सक्रिय आपूर्तिकर्ता",
      payment_terms: "डिफ़ॉल्ट भुगतान शर्तें",
      net_days: "नेट दिन",
      
      // Wastage & Production
      wastage_production: "अपशिष्ट और उत्पादन",
      wastage_reasons: "अपशिष्ट कारण",
      wastage_types: "समाप्त, गिरा, अधिक पका",
      yield_tolerances: "उत्पादन उपज सहिष्णुता",
      deviation_alert: "विचलन पर अलर्ट",
      
      // App Information & Support
      app_info_support: "ऐप जानकारी और सहायता",
      help_support: "सहायता और समर्थन",
      help_resources: "FAQ, संपर्क, ट्यूटोरियल",
      about_app: "इन्वेक्सिस के बारे में",
      app_version: "संस्करण 1.2.3",
      
      // Common
      save: "सहेजें",
      close: "बंद करें",
      add: "जोड़ें",
      edit: "संपादित करें",
      delete: "हटाएं",
      search: "खोजें",
      clear: "साफ़ करें",
      apply: "लागू करें",
      reset: "रीसेट करें"
    },
    
    // Sidebar/User Management (Hindi)
    sidebar: {
      user_access_management: "उपयोगकर्ता और एक्सेस प्रबंधन",
      invite_new_user: "नए उपयोगकर्ता को आमंत्रित करें",
      send_invitation: "नए टीम सदस्य को निमंत्रण भेजें",
      manage_users: "उपयोगकर्ताओं का प्रबंधन करें",
      total_users: "कुल उपयोगकर्ता",
      active: "सक्रिय",
      roles_permissions: "भूमिकाएं और अनुमतियाँ",
      roles_configured: "भूमिकाएं कॉन्फ़िगर की गईं",
      location_assignment: "स्थान असाइनमेंट",
      assign_users: "विशिष्ट स्थानों पर उपयोगकर्ताओं को असाइन करें",
      two_factor_authentication: "दो-कारक प्रमाणीकरण",
      enhanced_security: "सभी खातों के लिए बेहतर सुरक्षा",
      activity_logs: "गतिविधि लॉग",
      view_user_actions: "उपयोगकर्ता कार्यों और परिवर्तनों को देखें",
      business_location_management: "व्यवसाय और स्थान प्रबंधन",
      
      // Invite User Form
      name: "नाम",
      email: "ईमेल",
      phone: "फ़ोन",
      role: "भूमिका",
      select_role: "भूमिका चुनें",
      locations: "स्थान",
      select_locations: "स्थान चुनें",
      send_invite: "निमंत्रण भेजें",
      
      // User Management
      user_list: "उपयोगकर्ता सूची",
      status: "स्थिति",
      last_active: "अंतिम सक्रिय",
      actions: "कार्य",
      deactivate: "निष्क्रिय करें",
      activate: "सक्रिय करें",
      edit_user: "उपयोगकर्ता संपादित करें",
      delete_user: "उपयोगकर्ता हटाएं"
    },
    
    // Waste Reason Labels (Database translations) - Hindi
    wasteReasons: {
      "Pest Contamination": "कीट संदूषण",
      "Quality Control Rejection": "गुणवत्ता नियंत्रण अस्वीकृति",
      "Spoilage - Damaged": "खराब - क्षतिग्रस्त",
      "Spoilage - Expired": "खराब - समाप्त",
      "Storage Issue": "भंडारण समस्या",
      "Temperature Control Failure": "तापमान नियंत्रण विफलता",
      "Customer Return - Complaint": "ग्राहक रिटर्न - शिकायत",
      "Kitchen Mistake": "रसोई की गलती",
      "Over-production": "अधिक उत्पादन",
      "Under-production Waste": "कम उत्पादन अपशिष्ट",
      "Equipment Failure": "उपकरण विफलता",
      "Staff Training Error": "स्टाफ प्रशिक्षण त्रुटि",
      "billing errors": "बिलिंग त्रुटियां",
      "spillage": "रिसाव",
      "spoilage": "खराब होना",
      "Overcooked": "अधिक पका हुआ",
      "Customer Return": "ग्राहक रिटर्न",
      "Preparation Error": "तैयारी त्रुटि",
      "Spoilage (Prepared)": "खराब (तैयार)",
      "Excess Preparation": "अतिरिक्त तैयारी",
      "No wastage recorded": "कोई अपशिष्ट रिकॉर्ड नहीं",
      "Ingredient Waste": "सामग्री अपशिष्ट",
      "Dish Waste": "व्यंजन अपशिष्ट",
      "General Waste": "सामान्य अपशिष्ट",
      "Food Preparation": "खाद्य तैयारी",
      "Service Issue": "सेवा समस्या",
      "Food Quality": "खाद्य गुणवत्ता",
      "Inventory Management": "इन्वेंटरी प्रबंधन",
      "Administrative": "प्रशासनिक",
      "No Waste": "कोई अपशिष्ट नहीं"
    }
  }
};
export default translations;

